module.exports = "/_next/static/media/e3e2ff9cedaa31a7c1b3ff3401096926.svg";